export default {
  PROFILE: "प्रोफाइल",
  PURCHASEDMOCKTESTS: "खरीदे हुए मॉक टेस्ट्स",
  ATTEMPTS: "प्रयास",
  STATS: "स्टेटिस्टिक्स",
  COURSES: "कोर्सेज़",
  COURSE: "कोर्स",
  LASTLOGGEDIN: "अंतिम लॉगइन",
};
